export const PANEL_CONFIGURATIONS = {
  ALL_EXPANDED: 0,
  LEFT_COLLAPSED: 1,
  RIGHT_COLLAPSED: 2,
  MIDDLE_COLLAPSED: 3,
  ONLY_MIDDLE: 4,
  ONLY_RIGHT: 5,
};

export const LEFT_PANEL_COLLAPSE_EXPAND_MAP = {
  [PANEL_CONFIGURATIONS.LEFT_COLLAPSED]: PANEL_CONFIGURATIONS.ALL_EXPANDED,
  [PANEL_CONFIGURATIONS.ONLY_MIDDLE]: PANEL_CONFIGURATIONS.RIGHT_COLLAPSED,
  [PANEL_CONFIGURATIONS.ONLY_RIGHT]: PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED,
};

export const LEFT_PANEL_EXPAND_COLLAPSE_MAP = {
  [PANEL_CONFIGURATIONS.ALL_EXPANDED]: PANEL_CONFIGURATIONS.LEFT_COLLAPSED,
  [PANEL_CONFIGURATIONS.RIGHT_COLLAPSED]: PANEL_CONFIGURATIONS.ONLY_MIDDLE,
  [PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED]: PANEL_CONFIGURATIONS.ONLY_RIGHT,
};
